import {useSelector} from "react-redux";
import {selectEntity} from "state/selectors/data";
import {useCurrentUser} from "state/hooks/useCurrentUser";

export function useHasScope(id) {
    const userId = useCurrentUser();
    const user = useSelector(s=>selectEntity(s, 'db.users', userId));
    const scopes = user.scopes || [];
    return scopes.indexOf(id) > -1 || scopes.indexOf('master') > -1;
}